<template>

<el-row>
  <el-col :span="4"><div class="grid-content bg-purple"></div></el-col>
  <el-col :span="16"><div class="grid-content bg-purple-light">
    <div class="infoBox">
      <div class="infoTitle">{{title}}</div>
      <div class="publicTime">发布日期：{{publicTime}}</div>
      <div class="infoDetail" v-html="infoDetail"></div>
    </div>
  </div></el-col>
  <el-col :span="4"><div class="grid-content bg-purple"></div></el-col>
</el-row>
</template>
<script>
export default {
  data() {
    return {
      title:"",
      publicTime: "",
      infoDetail:"",
      id: "",
    };
  },
  created() {
  },
  mounted() {
    this.id = this.$route.params.id;
    this.getInfo();
  },
  props: [],
  methods: {
    getInfo: function(){
     this.$axios
        .post("/Broadcast/GetInformationDetail", {"infoCode":this.id}, {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        })
        .then(
          function (res) {
            if (res.data.Code == "10000") {
              console.log(res.data.Data);
              this.title = res.data.Data.Title;
              var strTime = res.data.Data.PublishTime;
              var time = strTime.substring(0, strTime.indexOf('T'));
              this.publicTime = time;
              this.infoDetail = res.data.Data.InfoContent;      
            }
            else
            {
              this.title=res.data.Message;
              this.publicTime = "";
              this.infoDetail = "";
            }
          }.bind(this)
        ) //bind(this)可以不用
        .catch(
          function (err) {
            if (err.response) {
              this.$message({
                message: "服务器端错误，数据加载失败！",
                type: "error",
              });
            }
          }.bind(this)
        ); //bind(this)可以不用      
    },
    getNowTime: function(){
      let date = new Date();
      let h = date.getHours();
      let m = date.getMinutes();
      let s = date.getSeconds();
      let t = h + ":" + m + ":" + s;
      return t;
    },
    
  },
  components: {
      
  }
};
</script>

<style scoped>
  .infoBox{
    border-left: 1px solid rgb(39, 36, 36);
    border-right: 1px solid rgb(39, 36, 36);
    border-bottom: 1px solid rgb(39, 36, 36);
  }
  .infoTitle{
    padding-top: 10px;
    padding-bottom: 10px;
    font-size: 26px;
    text-align: center;
  }
  .publicTime{
    padding-bottom: 10px;
    font-size: 16px;
    text-align: center;
  }  
  .infoDetail{
    padding: 20px;
    font-size: 16px;
    min-height: 630px;
  }    
  .el-row {
    margin-bottom: 0px;

  }
  .el-col {
    border-radius: 4px;
  }
  .bg-purple-dark {
    background: #99a9bf;
  }
  .bg-purple {
    background: #ffffff;
  }
  .bg-purple-light {
    background: #ffffff;
  }
  .grid-content {
    border-radius: 4px;
    min-height: 36px;
  }
  .row-bg {
    padding: 10px 0;
    background-color: #f9fafc;
  }
</style>


// WEBPACK FOOTER //
// src/components/informationDetail.vue